import {TypeContractStatusCode} from './types/contract.types';
import {DeviceStatusType} from './types/device.types';
import {TypeServiceRequestStatusCode} from './types/serviceRequest.types';
import {TypeServiceRequestImportStatusCode} from './types/serviceRequestImport.types';

export interface IStatusCodeTranslation {
  readonly contract: {[key in TypeContractStatusCode]: string};
  readonly serviceRequest: {[key in TypeServiceRequestStatusCode]: string};
  readonly serviceRequestImport: {[key in TypeServiceRequestImportStatusCode]: string};
  readonly device: {[key in DeviceStatusType]: string};
}

export const statusCodeTranslation: IStatusCodeTranslation = {
  contract: {
    CREATED: 'Создан',
    DONE: 'Исполнен',
    IMPORTED: 'Импортирован',
    IMPORTING: 'Импортируется',
    PROCESSING: 'Обрабатывается',
    ARCHIVED: 'В архиве',
  },
  serviceRequest: {
    CANCELLED: 'Отменена',
    CREATED: 'Создана',
    DONE: 'Завершена',
    READY_TO_PROCESS: 'Готова к исполнению',
    EXECUTED: 'Выполнена',
    IN_PROGRESS: 'Выполняется',
    NOTIFYING: 'Уведомление',
    REJECTED: 'Отклонена',
    DELAYED: 'Недопуск',
    APPROVED: 'Принята заказчиком',
    ARCHIVED: 'В архиве',
  },
  serviceRequestImport: {
    FINISHED_SUCCESSFULLY: 'Успешно завершен',
    FINISHED_WITH_ERRORS: 'Завершен с ошибками',
    PROCESSING: 'Обрабатывается',
    WAITING_FOR_START: 'Ожидание начала',
    REJECTED: 'Отклонен',
  },
  device: {
    FREE: 'На складе',
    BROKEN: 'В ремонте',
    ISSUED: 'В работе',
    INSTALLED: 'Установлен',
    RETIREMENT: 'Списан',
  },
};

export const statusCodeTranslationEntries = [
  ...Object.entries(statusCodeTranslation.contract),
  ...Object.entries(statusCodeTranslation.serviceRequest),
  ...Object.entries(statusCodeTranslation.serviceRequestImport),
];
